import { useSnackbar } from "notistack";
import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@mui/material";

import Header from "../../components/Header";
import Container from "../../componentsv2/Container";
import BI from "./BI";

import PainelControle from "./PainelControle";
import PesquisaUsuario from "./PesquisaUsuario";
import "./styles.css";

export default function ControleAcesso() {
  const location = useLocation();
  const usuario = location.state;
  const [aba, setAba] = useState(1);
  const { enqueueSnackbar } = useSnackbar();

  const [usuarioSelecionado, setUsuarioSelecionado] = useState(null);
  const [loading, setLoading] = useState(false);
  const [existemAlteracoesNaoSalvas, setExistemAlteracoesNaoSalvas] = useState(false);
  const [usuarioPendente, setUsuarioPendente] = useState(null);
  const [dialogTrocaUsuarioAberto, setDialogTrocaUsuarioAberto] = useState(false);

  useEffect(() => {
    if (usuario) {
      const usuarioOb = {
        usuario: {
          id: usuario.username.id,
          username: usuario.username.cod_usu,
          id_papel: null,
          controle: true,
        },
      };

      selecionarUsuario(usuarioOb.usuario);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [usuario]);

  function selecionarUsuario(proximoUsuario) {
    const usuarioAtualId = usuarioSelecionado?.id || null;
    const proximoUsuarioId = proximoUsuario?.id || null;

    if (usuarioAtualId === proximoUsuarioId) {
      setUsuarioSelecionado(proximoUsuario);
      return;
    }

    if (existemAlteracoesNaoSalvas && usuarioAtualId !== proximoUsuarioId) {
      setUsuarioPendente(proximoUsuario);
      setDialogTrocaUsuarioAberto(true);
      return;
    }

    setUsuarioSelecionado(proximoUsuario);
    setExistemAlteracoesNaoSalvas(false);
  }

  function confirmarTrocaUsuario() {
    setUsuarioSelecionado(usuarioPendente);
    setUsuarioPendente(null);
    setExistemAlteracoesNaoSalvas(false);
    setDialogTrocaUsuarioAberto(false);
  }

  return (
    <>
      <Header titulo="Controle Acesso" />
      <Container>
        <Dialog open={dialogTrocaUsuarioAberto}>
          <DialogTitle>Existem alterações não salvas</DialogTitle>
          <DialogContent>
            <DialogContentText>
              Salve ou cancele as alterações antes de trocar de usuário, ou continue para
              descartá-las.
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button
              type="button"
              onClick={() => {
                setUsuarioPendente(null);
                setDialogTrocaUsuarioAberto(false);
              }}
            >
              Voltar
            </Button>
            <Button type="button" variant="contained" onClick={confirmarTrocaUsuario}>
              Continuar
            </Button>
          </DialogActions>
        </Dialog>

        <div className="controle-acesso-tabs" id="container-aba-ctrl">
          <button
            type="button"
            id={aba === 1 ? "button-aba-ctrl-samples-selected" : "Aba1"}
            className="button-aba-ctrl"
            onClick={() => setAba(1)}
          >
            Controle
          </button>

          <button
            type="button"
            id={aba === 2 ? "button-aba-ctrl-samples-selected" : "Aba2"}
            className="button-aba-ctrl"
            onClick={() => setAba(2)}
          >
            BI
          </button>
        </div>

        {aba === 1 && (
          <>
            <PesquisaUsuario
              usuarioSelecionado={usuarioSelecionado}
              setUsuarioSelecionado={selecionarUsuario}
              enqueueSnackbar={enqueueSnackbar}
            />

            {usuarioSelecionado && (
              <PainelControle
                usuarioSelecionado={usuarioSelecionado}
                setUsuarioSelecionado={selecionarUsuario}
                setLoading={setLoading}
                loading={loading}
                onDirtyChange={setExistemAlteracoesNaoSalvas}
              />
            )}
          </>
        )}
        {aba === 2 && <BI />}
      </Container>
    </>
  );
}
